import { ColumnDef } from "@tanstack/react-table";
import { StripePaymentProps } from "../../store/actionType";

export const StripePaymentTableColumns: ColumnDef<StripePaymentProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorKey: "Amount",
    header: () => <span>Amount</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "CreatedAt",
    header: () => <span>Created At</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "MembershipDurationId",
    header: () => <span>Membership Duration</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Product",
    header: () => <span>Product</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Remarks",
    header: () => <span>Remarks</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "Status",
    header: () => <span>Status</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "TransactionId",
    header: () => <span>Transaction ID</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "UpdatedAt",
    header: () => <span>Updated At</span>,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "UserId",
    header: () => <span>User ID</span>,
    cell: (info) => info.getValue(),
  },
];
